// extracted by mini-css-extract-plugin
export var phone = "_11-0";